import React from 'react';
import CoverImage from './CoverImage';
import Greeting from './Greeting';

import ImageButton from './ImageButton';
import WasalaEvents from './WasalaEvents';
import CustomTour from './CustomTour';
import TourSection from './TourSection';
import BeutyOfSriLanka from './BeutyOfSriLanka';

import Footer from './Footer';







const Home = () => {
    return (
        <div>
            <CoverImage />
            <Greeting />

            <ImageButton />
            <CustomTour />
            <TourSection />
            <WasalaEvents />
            <BeutyOfSriLanka />
            <Footer />



        </div>
    );
};

export default Home;